<template>
  <div class="page_content pg_tnc">

    <div v-if="index === 0">
      <terms-of-use></terms-of-use>
    </div>
    <div v-else>
      <privacy-policy></privacy-policy>
    </div>
    <div class="mt-3">
      <div class="float-left">
        <input type="checkbox" id="tnc_chkbox" v-model="status" value="true">
        <label for="tnc_chkbox">I agree to the pragya systems <a href="javascript://" @click="index = 0">terms of use</a> and <a href="javascript://" @click="index = 1">privacy policy</a>.</label>
      </div>
      <div class="float-right">
        <b-button @click="tnCAccepted" :disabled="!status">Continue</b-button>
      </div>
    </div>

  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import TermsOfUse from './TermsOfUse'
  import PrivacyPolicy from './PrivacyPolicy'
  import { PACKAGE } from '../../../package_constants'

  export default {
    name: 'terms-and-conditions',
    props: ['userObj'],
    components: {
      TermsOfUse,
      PrivacyPolicy
    },
    data: () => {
      return {
        index: 0,
        status: false
      }
    },
    async mounted () {
      if (!this.userObj) {
        this.userObj = JSON.parse(localStorage.getItem('userobj'))
      }
      if (!this.userObj) {
        this.$root.$emit('serviceAvailable', true)
      } else {
        this.$store.commit('LOAD_USER_OBJECT', this.userObj)
        let token = this.userObj.password
        let institutionId = this.userObj.institutionId
        await this.loadInstitutionInfo({token: token, uuid: institutionId})
        await this.loadInstitutionInfoPackage({token: token, uuid: institutionId})
        let fullName = this.userObj.firstName + ' ' + this.userObj.lastName
        localStorage.setItem('userFullName', fullName)
        this.$store.commit('LOAD_USER_NAME', fullName)
        let role = this.userObj.roles[0].role
        localStorage.setItem('userrole', role)
        localStorage.setItem('institutionId', institutionId)
        let permission = this.userObj.permission
        this.$store.commit('LOAD_PERMISSION', permission)
        localStorage.setItem('userobj', JSON.stringify(this.userObj))
      }
    },
    methods: {
      ...mapActions([
        'setUserInfo',
        'loadSaveUser',
        'loadInstitutionInfo',
        'loadInstitutionInfoPackage'
      ]),
      showLoader () {
        if (this.$parent.$refs.loadingModal) {
          this.$parent.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$parent.$refs.loadingModal) {
          this.$parent.$refs.loadingModal.hide()
        }
      },
      tnCAccepted () {
        this.showLoader()
        if (!this.userObj) {
          this.userObj = JSON.parse(localStorage.getItem('userobj'))
        }
        let token = this.userObj.password
        if(token !== "*&^^&*"){
          localStorage.setItem('token', token)
        }
//        this.userObj.password = "*&^^&*"
        this.userObj.tnCAccepted = this.status
        this.loadSaveUser({uuid: this.userObj.uuid, user: this.userObj}).then(res => {
          this.hideLoader()
          if(token !== "*&^^&*"){
            this.userObj.password = token
          }
          this.setUserInfo(this.userObj)
          let role = res.roles[0].role
          if ((role === 'Student') && this.isXprizeDataOptOutEnabled) {
            this.$router.push('/dataPrivacy')
          } else {
            $('#launcher').show()
            this.navigateToDashboard(role)
            this.$root.$emit('loadChannelAndZendesk')
            this.$root.$emit('reloadLearnerDashboard')
          }
        })
      },
      navigateToDashboard (userRole) {
        this.$parent.isUserLoggedIn = true
        this.$parent.isServiceAvailable = true
        let role = userRole.toLowerCase()
        let url = '/user/track/' + role
        if ((role === 'instructor & admin') || (role === 'curator')) {
          url = '/user/track/admin'
        } else if (role === 'employer admin') {
          url = '/employer/admin'
        } else if (role === 'prospective student' || role === 'admitted student' || role === 'widget admin') {
          url = '/user/track/' + role.split(' ').join('_')
        }
        return this.$router.push(url)
      }
    },
    computed: {
      ...mapState({
        'enabledFeatures': state => state.institution.enabledFeatures
      }),
      isXprizeDataOptOutEnabled () {
        let xprizeDataOptOutFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_XPRIZE_DATA_OPT_OUT]
        if (xprizeDataOptOutFeature) {
          return xprizeDataOptOutFeature.enabled
        }
        return false
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/user/components/TermsAndConditions.vue